import * as React from "react";
import { useState, useEffect } from "react";
import PublicLogo from "./PublicLogo";
import { Box, Typography } from '@mui/material';

const PublicHeader: React.FC = () => {
  return (
    <>
      <Box
          display="flex"
          justifyContent="left"
          alignItems="center"
          height="115px"
          width="100%"
          bgcolor="#ffffff"
          sx={{
              borderRadius: "16px",
          }}
          p={"20px"}
      >
        <PublicLogo />
      </Box>
    </>
  );
};

export default PublicHeader;

